<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import TableListComponent from '@/components/TableList/main.vue';
import ButtonActiveFilter from '@/components/ButtonColFilter/main.vue';

import { employeeMethods, masterMethods } from '@/state/helpers';
import { checkPermission, checkPermissionName } from '@/utils/handlers';
import { keyMaster, NAMEROLEFIXED } from '@/config/constants';
import { truncateText } from '@/utils/format';
import { InputCheckBox } from '@/components/Input';
import { STATUS_OPTIONS } from '@/views/pages/employee/form/index.js';

export default {
    page: {
        title: 'パルディア社員一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        KeyWordTag,
        Layout,
        Multiselect,
        TableListComponent,
        ButtonActiveFilter,
        InputCheckBox
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('employee.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            listData: [],
            listDataMasterTeam: [],
            listDataMasterGroup: [],
            listDataMasterRoles: [],
            form: {
                name: '',
                kana_name: '',
                email: '',
                phone_number: ''
            },
            filter: {
                team: '',
                role: '',
                role_name: '',
                status: [0, 1]
            },
            checkShowFilter: false,
            configKeyword: {
                arrayTag: [],
                placeholder: '名前　名前(カナ) ...',
                isShowLable: true
            },
            configTable: {
                widthAction: 200,
                headers: [
                    {
                        label: 'No',
                        width: 50
                    },
                    {
                        label: this.$t('pageEmployee.name'),
                        width: 400
                    },
                    {
                        label: this.$t('pageEmployee.role'),
                        width: 150
                    },
                    {
                        label: this.$t('pageEmployee.team'),
                        width: 150
                    },
                    {
                        label: this.$t('pageEmployee.email'),
                        width: 230
                    },
                    {
                        label: this.$t('pageEmployee.cellphoneNumber'),
                        width: 180
                    }
                ]
            },
            configPage: {
                total: 0,
                limit: 30,
                page: 1
            },
            isLoading: false,

            isActive: true,
            heightSizeTable: '',
            STATUS_OPTIONS
        };
    },
    watch: {},
    mounted() {
        this.getList();
        this.getListMasterGroup();
        this.getListMasterRoles();
    },

    methods: {
        checkPermission,
        ...masterMethods,
        ...employeeMethods,
        truncateTextTable(text) {
            return truncateText(text);
        },
        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
            if (this.checkShowFilter) {
                this.configKeyword.placeholder = '';
            } else {
                this.configKeyword.placeholder = '名前　名前(カナ) ...';
            }
        },
        checkPermiss(listRole) {
            return checkPermissionName(listRole);
        },
        getListMasterRoles() {
            this.listMaster('roles').then((data) => {
                if (!data || data.length <= 0) return;
                this.listDataMasterRoles = data
                    .map((item) => {
                        item.text = NAMEROLEFIXED.find((o) => o.id === item.id)?.text ?? '';
                        return item;
                    })
                    .filter((role) => !role.name.includes('partner'));
            });
        },
        getListMasterGroup() {
            this.listMaster(keyMaster['employee.department']).then((data) => {
                this.listDataMasterGroup = data;
                this.listDataMasterTeam = data[1]?.data || [];
            });
        },
        goToEdit(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        // setTeam() {
        //     this.listDataMasterTeam = [];
        //     this.filter.team = '';
        //     let i = this.listDataMasterRoles.findIndex((x) => x.id == this.filter.role.id);
        //     if (i >= 0) {
        //         this.filter.role_name = this.listDataMasterRoles[i].name;
        //         if (this.filter.role_name === 'sale') {
        //             let index = this.listDataMasterGroup.findIndex((x) => x.id == 1);
        //             this.listDataMasterTeam = this.listDataMasterGroup[index].data;
        //         }
        //         if (this.filter.role_name === 'instructor') {
        //             let index = this.listDataMasterGroup.findIndex((x) => x.id == 5);
        //             this.listDataMasterTeam = this.listDataMasterGroup[index].data;
        //         }
        //     }
        // },
        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            if (this.checkShowFilter) {
                if (this.form) {
                    for (const [key, value] of Object.entries(this.form)) {
                        if (key && value) query.push(`search[${key}]=${encodeURIComponent(value)}`);
                    }
                }

                if (this.filter) {
                    let shallCopy = { ...this.filter };
                    shallCopy.role = this.filter.role?.id ?? '';
                    shallCopy.team = this.filter.team?.id ?? '';
                    shallCopy.status = this.filter.status.join(',');
                    for (const [key, value] of Object.entries(shallCopy)) {
                        if (key && value) query.push(`filters[${key}]=${encodeURIComponent(value)}`);
                    }
                }
            } else {
                if (this.configKeyword.arrayTag.length > 0) {
                    query.push(`q=${this.configKeyword.arrayTag.toString()}`);
                }
            }

            return query.join('&');
        },
        getList() {
            this.isLoading = true;
            let query = this.getQueryString();
            this.listEmployee(query).then((data) => {
                this.listData = data.data;
                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listData.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            });
        },

        search() {
            this.getList();
        },
        clear() {
            this.form = {
                name: '',
                kana_name: '',
                email: '',
                phone_number: ''
            };
            this.filter = {
                team: '',
                role: '',
                department: '',
                status: [0, 1]
            };
            this.configKeyword.arrayTag = [];
            this.getList();
        },

        handleRemoveSetTeam() {
            this.listDataMasterTeam = [];
            this.filter = {
                team: '',
                role: '',
                department: '',
                status: [0, 1]
            };
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row form__common--center">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex" style="gap: 0.5rem">
                        <h3 class="mb-0 title--screen">パルディア社員検索</h3>
                        <div class="ml-auto">
                            <ButtonActiveFilter
                                :active.sync="isActive"
                                @sizeHeight="(height) => (heightSizeTable = height)"
                                :smallCol="577"
                                :largeCol="53.9"
                            />
                        </div>
                    </div>
                    <div v-if="isActive" class="card-body position-relative">
                        <div class="row justify-content-center">
                            <div class="col-sm-6 position-static">
                                <form class="needs-validation" autocomplete="off">
                                    <div v-if="!checkShowFilter" class="row form-group">
                                        <div class="col-sm-12">
                                            <KeyWordTag :config="configKeyword" class="" />
                                        </div>
                                    </div>
                                    <div v-if="checkShowFilter">
                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom01">{{ $t('pageEmployee.name') }}</label>
                                            <div class="w-100">
                                                <input id="validationCustom01" v-model="form.name" type="text" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom02">{{ $t('pageEmployee.name_kana') }}</label>
                                            <div class="w-100">
                                                <input id="validationCustom02" v-model="form.kana_name" type="text" class="form-control" />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom03">{{ $t('pageEmployee.email') }}</label>
                                            <div class="w-100">
                                                <input
                                                    id="validationCustom03"
                                                    v-model="form.email"
                                                    autocomplete="off"
                                                    type="email"
                                                    class="form-control"
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom04">{{ $t('pageEmployee.role') }}</label>
                                            <div class="col-sm-6 p-0">
                                                <Multiselect
                                                    :id="`select-role_id-object`"
                                                    :value.sync="filter.role"
                                                    :options="listDataMasterRoles"
                                                    :config="{
                                                        trackBy: 'id',
                                                        label: 'text',
                                                        valueSync: null,
                                                        error: false,
                                                        isRemove: false,
                                                        isRequired: false
                                                    }"
                                                    @remove="handleRemoveSetTeam()"
                                                />
                                                <!-- @select="setTeam()" -->
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="['administrator', 'sale_instructor'].includes(filter.role?.name)">
                                            <label class="col-sm-2 mw--form" for="validationCustom05">{{ $t('pageEmployee.team') }}</label>
                                            <div class="col-sm-6 p-0">
                                                <Multiselect
                                                    :id="`select-role_id-object`"
                                                    :value.sync="filter.team"
                                                    :options="listDataMasterTeam"
                                                    :config="{
                                                        trackBy: 'id',
                                                        label: 'value',
                                                        valueSync: null,
                                                        error: false,
                                                        isRemove: false,
                                                        isRequired: false
                                                    }"
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom07">{{ $t('pageEmployee.cellphoneNumber') }}</label>
                                            <div class="w-100">
                                                <input id="validationCustom07" v-model="form.phone_number" type="text" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-sm-2 mw--form" for="validationCustom06">{{ $t('pageEmployee.statusAccount') }}</label>
                                            <div class="w-100 d-flex">
                                                <div v-for="itemStatus in STATUS_OPTIONS" :key="itemStatus.id + 'stt'">
                                                    <InputCheckBox
                                                        class="mr-4"
                                                        :model.sync="filter.status"
                                                        :name="`status_id-object`"
                                                        :id="`status_id-object-${itemStatus.id}`"
                                                        :value="itemStatus.id"
                                                        :label="itemStatus.text"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="text-center mt-4">
                                        <button type="button" @click="clear()" class="btn btn-common btn-outline-primary">
                                            <i class="ri-restart-line"></i>{{ $t('btn.clear') }}
                                        </button>
                                        <button type="button" @click="search()" class="btn btn-common btn-primary ml-3">
                                            <i class="ri-search-line"></i>{{ $t('btn.search') }}
                                        </button>
                                        <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary">
                                            <i class="ri-equalizer-line"></i>絞り込み条件を表示
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-0">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">
                            パルディア社員検索結果 <span>件数（{{ configPage.total }})</span>
                        </h3>
                    </div>
                    <div class="card-body">
                        <TableListComponent
                            :heightTable="heightSizeTable"
                            :config="configTable"
                            :dataList="listData"
                            :isLoading="isLoading"
                            :configPage.sync="configPage"
                            :stickyAction="true"
                            @onChangePage="getList()"
                        >
                            <template #row="{ row, index }">
                                <tr @dblclick="goToEdit('/employee/view', row)">
                                    <td>
                                        <div class="el-table__cell text-left">
                                            {{ index }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">
                                            {{ truncateTextTable(row.name + (row.name_kana ? row.name_kana : '')) }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">{{ row.role ? $t(row.role.name) : '' }}</div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">
                                            {{ row.team ? row.team.value : '' }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">
                                            {{ row.email }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="el-table__cell text-left">
                                            {{ row.phone_number }}
                                        </div>
                                    </td>
                                    <td class="sticky_action text-left" style="z-index: 15">
                                        <div class="el-table__cell text-left">
                                            <a
                                                v-if="checkPermission('employee.view')"
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-info mr-2"
                                                @click="goToEdit('/employee/view', row)"
                                                ><i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}</a
                                            >
                                            <a
                                                v-if="checkPermission('employee.edit')"
                                                href="javascript:void(0)"
                                                class="btn btn-common-sml btn-primary mr-2"
                                                @click="goToEdit('/employee/form', row)"
                                                ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </TableListComponent>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
td,
th {
    vertical-align: middle;
}
::v-deep .multiselect__single,
::v-deep .multiselect__option {
    white-space: pre-line;
}
</style>
